import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import dateUtil from '../utils/date.util'
import itemApi, { ItemData } from '../apis/item.api'
import itemService from '../services/item.service'
import SearchPicker, { SearchPickerOption } from '../components/SearchPicker'
import Card from '../components/Card'
import Row from '../components/Row/Row'
import CustomDatePicker from '../components/CustomDatePicker'
import PageHeading from '../components/PageHeading'
import ReportButtons from './ReportButtons'

interface Props {
  onSearchClick: (data: PackTraceReportFormData) => void
  onExportClick: (data: PackTraceReportFormData) => void
}

interface State {
  fromDate: string
  toDate: string
  item: string
  itemId: number | null
  items: ItemData[]
}

export interface PackTraceReportFormData {
  fromDate: string
  toDate: string
  itemId: number | null
}

export default class PackTraceReportForm extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      fromDate: dateUtil.now(),
      toDate: dateUtil.now(),
      item: '',
      itemId: null,
      items: []
    }
    this.handleDateChange = this.handleDateChange.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleItemSearch = this.handleItemSearch.bind(this)
    this.handleItemSelect = this.handleItemSelect.bind(this)
    this.handleSearchClick = this.handleSearchClick.bind(this)
    this.handleExportClick = this.handleExportClick.bind(this)
    this.handleItemBlur = this.handleItemBlur.bind(this)
  }

  get itemSearchOptions () {
    return itemService.searchOptions(this.state.items)
  }

  get formData (): PackTraceReportFormData {
    const { fromDate, toDate, itemId } = this.state
    return { fromDate, toDate, itemId }
  }

  searchItem (term: string) {
    itemApi.search(term, items => {
      if (!items) return
      this.setState({ items })
    })
  }

  handleDateChange (name: string, date: string) {
    if (name === 'from') this.setState({ fromDate: date })
    if (name === 'to') this.setState({ toDate: date })
  }

  handleInputChange (name: string, value: string) {
    if (name === 'item') this.setState({ itemId: null, item: value })
  }

  handleItemSearch (name: string, term: string) {
    this.searchItem(term)
  }

  handleItemSelect (name: string, option: SearchPickerOption) {
    const itemId = option.id as number
    this.setState({ itemId, items: [] })
  }

  handleItemBlur () {
    this.setState({ items: [] })
  }

  handleSearchClick () {
    this.props.onSearchClick(this.formData)
  }

  handleExportClick () {
    this.props.onExportClick(this.formData)
  }

  render () {
    return (
      <Card>
        <PageHeading
          text={i18n("Pack Trace Report")}
          doc='reports-preview-and-export-pack-traces-report' />
        <Row column={2}>
          <CustomDatePicker
            from={this.state.fromDate}
            to={this.state.toDate}
            time={true}
            onChange={this.handleDateChange} />
          <Row column={2}>
            <SearchPicker
              name="item"
              value={this.state.item}
              options={this.itemSearchOptions}
              label={i18n("Item")}
              onSearch={this.handleItemSearch}
              onChange={this.handleInputChange}
              onSelect={this.handleItemSelect}
              onBlur={this.handleItemBlur} />
          </Row>
        </Row>
        <ReportButtons
          onSearch={this.handleSearchClick}
          onExport={this.handleExportClick} />
      </Card>
    )
  }
}
